<script>
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import { nlToBr } from '@utils/index'
  export default {
    components: {  Slick },
    props: {
      aboutTeamMember: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        list: [
          {
            image: require('@assets/images/course/man.png'),
            name: '林嘉勲',
            position: '董事長',
            education: '交通大學電子研究所',
            experience: '本公司總經理'
          },
          {
            image: require('@assets/images/course/man.png'),
            name: '姜有謨',
            position: '副董事長',
            education: '中國文化大學',
            experience: '本公司執行長'
          },
          {
            image: require('@assets/images/course/man.png'),
            name: '黃素娥',
            position: '總經理',
            education: '銘傳大學資管科',
            experience: '本公司執行副總'
          },
          {
            image: require('@assets/images/course/man.png'),
            name: '金可玫',
            position: '財務長兼發言人',
            education: '德明財經科技大學銀行管理科',
            experience: '本公司財務長'
          }
        ],
        slickOption: {
          slidesToShow: 4,
          slidesToScroll: 1,
          // centerMode: true,
          dots: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 1350,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            },
          ]
        }
      }
    },
    methods: {
      nlToBr(item) {
        return nlToBr(item)
      }
    }
  }
</script>
<template>
  <section :class="$style.sectionTeam" class="section">
    <div class="container">
      <BaseSectionTitle title="經營團隊" class="text-center"/>
      <!-- <div class="row sectionTeam__list">
        <div v-for="(item, $index) in list" :key="$index" class="col-md-6 col-lg-3">
          <div class="bg-white sectionTeam__item text-center">
            <div class="mt-3 top pb-4">
              <h3 class="name mb-1">{{ item.name }}</h3>
              <span class="position color-gray-6"> {{ item.position }}</span>
            </div>
            <div class=" pt-4 bottom text-left">
              <div class="education color-gray-6">學歷：{{ item.education }}</div>
              <span class="experience color-gray-6 mt-1">經歷：{{ item.experience }}</span>
            </div>
          </div>
        </div>
      </div> -->
      <Slick
        v-if="!!aboutTeamMember.length"
        ref="carouselAdvantage"
        :options="slickOption"
        class="sectionTeam__list"
      >
        <template v-for="(item, $index) in aboutTeamMember">
          <div :key="$index" class="bg-white sectionTeam__item text-center">
            <div class="mt-3 top pb-4">
              <h3 class="name mb-1">{{ item.name }}</h3>
              <span class="position color-gray-6"> {{ item.title }}</span>
            </div>
            <div class=" pt-4 bottom text-left">
              <p  class="color-gray-6 career" v-html="nlToBr(item.career)"></p>
              <!-- <div class="education color-gray-6">學歷：{{ item.education }}</div>
              <span class="experience color-gray-6 mt-1">經歷：{{ item.experience }}</span> -->
            </div>
          </div>
        </template>
      </Slick>
    </div>
  </section>
</template>
<style lang="scss" module>
  .sectionTeam {
    background: #F5F5F5;
    @include max-md {
      padding-bottom: 3.56rem;
    }
    :global {
      .sectionTeam {
        &__list {
          .slick-track {
            display: flex;
          }
          .slick-slide {
            margin: 0 19px;
            height: inherit;
            padding: 1.5rem 0;
            @include max-md {
              // padding: 0 19px;
            }
            > div {
              height: 100%;
            }
          }
          .slick-list {
            margin: 0 -19px;
          }
        }

        &__item {
          padding: 42px 35px;
          box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);
          height: 100%;
          @include max-lg {
            margin-bottom: 1rem;
          }

          .name {
            font-size: 1.33rem;
            font-family: 微軟正黑體;
            font-weight: 600;
          }

          .position {
            font-size: 1rem;
          }

          .top {
            border-bottom: 1px solid #B1BACA;
          }

          .bottom {
            width: fit-content;
            margin: 0 auto;
          }

          .career {
            font-size: 1rem;
          }
        }
      }
      .slick-dots {
        @include list-unstyled;

        position: absolute;
        bottom: -2rem;
        left: 50%;
        display: flex;
        justify-content: center;
        margin-bottom: 0;
        transform: translateX(-50%);
        @include max-md {
          bottom: -2rem;
        }
        li {
          padding: 0 0.5rem;

          button {
            display: block;
            width: 10px;
            height: 10px;
            padding: 0;
            font-size: 0;
            background: #B1BACB;
            border: none;
            border-radius: 15px;
            transition: width 0.3s;
            appearance: none;
          }

          &.slick-active {
            button {
              width: 47px;
              background: $color-primary;
            }
          }
        }
      }
    }
  }
</style>
